export var defaultCurrencies = [
    {
        symbol: '₽',
        name: 'РОССИЙСКИЙ РУБЛЬ',
        shortname: 'руб.',
        code: 'rub',
    },
    {
        symbol: 'Br',
        name: 'БЕЛОРУССКИЙ РУБЛЬ',
        shortname: 'бел. руб.',
        code: 'byn',
    },
    {
        symbol: 'UZS',
        name: 'УЗБЕКСКИЙ СУМ',
        shortname: 'узб. сум.',
        code: 'uzs',
    },
    {
        symbol: '₸',
        name: 'ТЕНГЕ',
        shortname: 'тенге',
        code: 'kzt',
    },
    {
        symbol: '$',
        name: 'USD',
        shortname: 'USD',
        code: 'usd',
    },
    {
        symbol: '€',
        name: 'EUR',
        shortname: 'EUR',
        code: 'eur',
    },
];
export var getCurrencyByCode = function (code) {
    return defaultCurrencies.find(function (c) { return c.code === code; });
};
